import { ContainedIcon } from '@floriday/floriday-ui'
import { RfhColors } from '../../config/florimixColors'
import { Button, Typography, Paper, Box } from '@mui/material'
import type { PaletteColor } from '@mui/material/styles'

export type DashboardCardProps = {
  title: string
  subtitle: string
  buttonText: string
  onClick?: () => void
  icon?: React.ReactNode
  color: Pick<PaletteColor, 'main' | 'light' | 'dark'>
  to?: string
}

export const DashboardCard = ({
  title,
  subtitle,
  buttonText,
  onClick,
  icon,
  color,
  to,
}: DashboardCardProps) => {
  return (
    <Paper
      sx={{ p: 2, display: 'flex', flexDirection: 'row', gap: 2 }}
      elevation={1}
      onClick={onClick}
    >
      <ContainedIcon
        variant='circle'
        color={color}
        sx={{ alignSelf: 'center' }}
      >
        {icon}
      </ContainedIcon>
      <Box sx={{ pr: 2 }}>
        <Typography variant='body1'>{subtitle}</Typography>
        <Typography variant='h3'>{title}</Typography>
      </Box>
      <Button
        variant='contained'
        color='primary'
        href={to}
        sx={{
          color: RfhColors.white,
          flexGrow: 1,
        }}
      >
        <Box
          component='span'
          sx={{
            whiteSpace: 'nowrap',
            '@media (max-width: 390px)': {
              whiteSpace: 'normal',
              width: 'min-content',
            },
          }}
        >
          {buttonText}
        </Box>
      </Button>
    </Paper>
  )
}
